import { ErrorLogComponent } from '@cian/error-log-component';
import { FC } from 'react';
import { Provider } from 'react-redux';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from 'shared/utils/applicationContext';
import { UiKitRoot } from '@cian/ui-kit';
import { GuideTrackingProvider } from '../GuideTracking';
import { PagesContainer } from '../Pages';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: FC<IApplicationProps> = ({ reduxStore, context }) => {
  const { logger } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot>
          <Provider store={reduxStore}>
            <GuideTrackingProvider>
              <PagesContainer />
            </GuideTrackingProvider>
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
